export function getBranchDisplayName(branch: {
  fantasyName?: string | null;
  name?: string | null;
}): string {
  const fantasy = branch.fantasyName?.trim() ?? "";
  if (fantasy.length > 0) {
    return fantasy;
  }
  return branch.name ?? "";
}
